/* eslint-disable tss-unused-classes/unused-classes */
/* eslint-disable react-hooks/exhaustive-deps */
import { gridSelectionActions } from '@AMIEWEB/Common/Grid/GridSelection/GridSelection.redux';
import {
  FacilityUnitActions,
  FacilityUnitKey,
  FacilityUnitReducer,
} from '@AMIEWEB/Facility/FacilityDetails/FacilityTabs/UnitTab/Store/FacilityUnit.redux';
import { facilityUnitsSaga } from '@AMIEWEB/Facility/FacilityDetails/FacilityTabs/UnitTab/Store/FacilityUnit.saga';
import {
  isEditLoader,
  selectActiveStep,
  selectEditOrderId,
  selectIsEditSuccess,
  selectNewOrderCreatedFromUnit,
  selectOrderLicenseOptions,
  selectUnitId,
} from '@AMIEWEB/NewOrder/Store/Order.selectors';
import { orderCreationNewActions } from '@AMIEWEB/NewOrder/Store/OrderCreation.actions';
import { orderCreationNewReducer, orderCreationNewSliceKey } from '@AMIEWEB/NewOrder/Store/OrderCreation.redux';
import { orderCreationNewSaga } from '@AMIEWEB/NewOrder/Store/OrderCreation.saga';
import { orderCreationActions, orderDetailsEditInitializationAction } from '@AMIEWEB/Order/Store/OrderCreation.actions';
import { globalActions } from 'app/ApplicationRoot/Global.redux';
import { DetailsPage } from 'app/layout/pages/DetailsPage';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation, useParams } from 'react-router-dom';
import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import OrderDetailHeader from '../Common/OrderDetailHeader';
import { NewOrderBody } from './NewOrderBody';
import { GlobalCategory, IBreadCrumb, IOrderCreationParams, OrderCreationStepEnum } from '@AMIEWEB/NewOrder/types';
import { selectOrderDetailsUIView } from '@AMIEWEB/Order/Store/Order.selectors';
import {
  createOrderPreferenceActions,
  createOrderPreferenceReducer,
  createOrderPreferenceSliceKey,
} from 'store/redux-store/create-order-preferences/slice';
import { orderCreationNewPreferenceSaga } from 'store/redux-store/create-order-preferences/saga';
import { initialSubmissionPreferences } from 'store/redux-store/create-order-preferences/initialState';
import { selectFilterCertificationsDecision } from '@AMIEWEB/Order/Store/OrderCreation.selectors';
import { useDecision } from '@optimizely/react-sdk';
import { ff_order_ui_qualificationlist } from 'app/constants/FeatureFlags/Order/Keys';
import { selectFacility } from '@AMIEWEB/Facility/FacilityStore/Facility.selector';

export const NewOrder: React.FC = () => {
  useInjectReducer({ key: FacilityUnitKey, reducer: FacilityUnitReducer });
  useInjectSaga({ key: FacilityUnitKey, saga: facilityUnitsSaga });
  useInjectReducer({ key: orderCreationNewSliceKey, reducer: orderCreationNewReducer });
  useInjectSaga({ key: orderCreationNewSliceKey, saga: orderCreationNewSaga });
  useInjectReducer({ key: createOrderPreferenceSliceKey, reducer: createOrderPreferenceReducer });
  useInjectSaga({ key: createOrderPreferenceSliceKey, saga: orderCreationNewPreferenceSaga });

  const history = useNavigate();
  const location = useLocation();
  const { id: facilityId } = useParams() as unknown;
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const isEditOrder = location.pathname.includes('/edit');
  const orderId = useSelector(selectEditOrderId);
  const isEditSuccess = useSelector(selectIsEditSuccess);
  const activeStep = useSelector(selectActiveStep);
  const loader = useSelector(isEditLoader);
  const orderDetailsUIView = useSelector(selectOrderDetailsUIView);
  const selectedUnitId = useSelector(selectUnitId);
  const selectDecision = useSelector(selectFilterCertificationsDecision);
  const [filterCertListFlag] = useDecision(ff_order_ui_qualificationlist);
  const facilityValue = useSelector(selectFacility);
  const orderLicenseOptions = useSelector(selectOrderLicenseOptions);
  const title = !!orderId ? t('order.newOrderCreation.editOrder') : t('navStick.facilityOverlay.newOrder');
  const isNewOrderCreatedFromUnit = useSelector(selectNewOrderCreatedFromUnit);
  let breadCrumbOptions: IOrderCreationParams[] = [];
  if (selectDecision === undefined || selectDecision === null) {
    dispatch(orderCreationActions.setCertificationsFlagDecision(filterCertListFlag.enabled));
  }

  useEffect(() => {
    if (isEditOrder) {
      dispatch(orderDetailsEditInitializationAction({ id: parseInt(facilityId) }));
      dispatch(orderCreationActions.requestOrderCreationRequirementTypesDetailsAction());
      dispatch(orderCreationNewActions.getOrderLicenseCompactStatusOptions());
    } else {
      dispatch(FacilityUnitActions.requestFacilityUnitsList({ id: parseInt(facilityId) }));
      //TODO can include all options values for order creation here
    }
    if (activeStep === OrderCreationStepEnum.UnitSelection && isEditOrder) {
      dispatch(orderCreationNewActions.setActiveStep(OrderCreationStepEnum.OrderRequirements));
    }
    dispatch(orderCreationNewActions.getOptionsForPage2());
    return () => {
      dispatch(gridSelectionActions.reset());
      dispatch(orderCreationNewActions.reset());
      dispatch(globalActions.closeBanner());
      dispatch(createOrderPreferenceActions.setIsUnitInherited(false));
      dispatch(createOrderPreferenceActions.setCustomTabValue(undefined));
      dispatch(createOrderPreferenceActions.setPreferences(initialSubmissionPreferences));
    };
  }, []);

  


  useEffect(() => {
    if (isEditSuccess || loader.isSaveFailed) history(`/order/${orderId}`);
  }, [isEditSuccess, loader.isSaveFailed]);

  useEffect(() => {
    const faciltyDetail = facilityValue?.facilityResponse?.location?.state ?? facilityValue?.response?.location?.state;
    if (faciltyDetail && orderLicenseOptions?.length === 0)
      dispatch(orderCreationNewActions.getOrderLicenseOptions(faciltyDetail));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [facilityValue]);

  useEffect(() => {
    if (
      isEditOrder &&
      activeStep === OrderCreationStepEnum.OrderRequirements &&
      orderDetailsUIView?.currentStep === 'ViewOrderDetails'
    )
      dispatch(orderCreationNewActions.onRequestEditOrder({ orderId: facilityId }));
  }, [orderDetailsUIView?.currentStep]);

  const getBreadCrumbs = () => {
    let defaultArr = [
      {
        title: !isEditOrder ? `FID ${facilityId}` : `FID ${orderDetailsUIView?.orderDetails?.facility?.facilityId} `,
        clickable: true,
      },
    ];
    breadCrumbOptions = [
      {
        category: GlobalCategory.facility,
        value: !isEditOrder ? parseInt(facilityId) : orderDetailsUIView?.orderDetails?.facility?.facilityId,
      },
    ];
    if (isNewOrderCreatedFromUnit) {
      defaultArr.push({
        title: `UID ${selectedUnitId}`,
        clickable: true,
      });
      breadCrumbOptions.push({
        category: GlobalCategory.unit,
        value: selectedUnitId,
      });
    }

    return {
      items: defaultArr,
      onClick: (event, item: IBreadCrumb) => {
        if (item.title.includes('FID')) {
          dispatch(FacilityUnitActions.setSelectedUnit(null));
          const targetFacilityId = !isEditOrder ? facilityId : orderDetailsUIView?.orderDetails?.facility?.facilityId;
          history(`/facility/${targetFacilityId}`);
        }
        if (item.title.includes('UID')) {
          const targetFacilityId = !isEditOrder ? facilityId : orderDetailsUIView?.orderDetails?.facility?.facilityId;
          history(`/facility/${targetFacilityId}/unit/${selectedUnitId}`);
          dispatch(orderCreationNewActions.setSelectedUnitItem(null));
          dispatch(orderCreationNewActions.setSelectedUnitId(null));
        }
      },
    };
  };

  return (
    <>
      {!loader.isLoader && !loader.isSaveFailed && (
        <DetailsPage
          head={<OrderDetailHeader />}
          breadcrum={getBreadCrumbs()}
          children={<NewOrderBody breadCrumbOptions={breadCrumbOptions} />}
          title={` / ${title}`}
          removeExtraTopSpace
        />
      )}
    </>
  );
};
